import { HttpClient, RouteGenerator } from "silver";
import { MyonEnv, isEnvUserAuthorized } from "shared/Api/MyonEnv";
import { GradeLevel } from "shared/Api/GradeLevel";

export class SetUserGradeLevelService {

	private abortController: AbortController = new AbortController();

	constructor(
		private httpClient: HttpClient,
		private router: RouteGenerator,
		private env: MyonEnv
	) { }

	public async set(gradeLevelId: GradeLevel): Promise<void> {
		if (!isEnvUserAuthorized(this.env)) {
			throw new Error("Not authorized");
		}
		this.abortController.abort(); // don't bother completing old sets
		this.abortController = new AbortController();
		const url = this.router.generate("api/user", "gradeLevel", { userId: this.env.auth.userId }, "json");
		await this.httpClient.post(url, {
			abortController: this.abortController,
			body:            {
				gradeLevelId: Number(gradeLevelId)
			}
		});
	}
}
